/**
 * Bring a form's error message into view and give it focus, once the
 * render that shows it has landed (the next task, as the field path does:
 * the controls a request disabled are enabled again by then).
 *
 * Why (PR 3 review): on a phone a dialog's body scrolls, and a save's
 * error sat at its end, below what the screen showed, while focus — left
 * on the submit button the request had disabled — fell back to the dialog
 * or <body>. A sighted phone user saw the button come back and nothing
 * else. The alert must carry `tabIndex={-1}`.
 */
export function revealLater(ref) {
  setTimeout(() => {
    const el = ref.current;
    if (!el) return;
    el.scrollIntoView?.({ block: "nearest" });
    el.focus({ preventScroll: true });
  }, 0);
}
